import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { EmbryoService } from '../../../Services/Embryo.service';
import { AuthService } from '../../../Services/Auth.service';
import { TranslateService } from '@ngx-translate/core';
declare var $: any;

@Component({
  selector: 'HeaderOne',
  templateUrl: './HeaderOne.component.html',
  styleUrls: ['./HeaderOne.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderOneComponent implements OnInit {
   toggleActive     : boolean = false;
   cartProducts     : any;
   popupResponse    : any;

   constructor(public embryoService: EmbryoService, public authService:AuthService, translate:TranslateService) {
      console.log("headerone - const");
   }

   ngOnInit() {
      console.log("headerone - init");
   }

   public toggleSearch() {
      $('app-main').toggleClass('form-open');
   }

   public toggleSidebar()
   {
      console.log("headerone - init");
      this.embryoService.sidenavOpen = !this.embryoService.sidenavOpen;
   }

   public openConfirmationPopup(value:any) {
      let message = "Are you sure you want to delete this product?";
      this.embryoService.confirmationPopup(message).
         subscribe(res => {this.popupResponse = res},
                   err => console.log(err),
                   ()  => this.getPopupResponse(this.popupResponse, value, 'cart')
                  );
   }

   public getPopupResponse(response:any, value:any, type) {
      if(response) {
         if(type == 'cart'){
            this.embryoService.removeLocalCartProduct(value);
         } 
      }
   }

   public selectedCurrency(value) {
      this.embryoService.currency = value;
   }

   public selectedLanguage(value) {
      this.embryoService.language = value;
   }

  
}
